const DENIED_PARAM_PREFIXES = ['utm_'];

const DENIED_PARAMS = new Set([
  // cache-busting legacy dei bundle vecchi del version check
  // (vedi docs/VERSION_CHECK.md, "Migrazione dai bundle vecchi")
  'app_version',
  'fbclid',
  'gclid',
  'gclsrc',
  'dclid',
  'gbraid',
  'wbraid',
  'msclkid',
  'ttclid',
  'twclid',
  'igshid',
  'mc_cid',
  'mc_eid',
  '_hsenc',
  '_hsmi',
]);

function isDeniedParam(name: string): boolean {
  return (
    DENIED_PARAMS.has(name) ||
    DENIED_PARAM_PREFIXES.some((prefix) => name.startsWith(prefix))
  );
}

export function removeDeniedParams(url: URL): boolean {
  const deniedNames = [...url.searchParams.keys()].filter(isDeniedParam);
  deniedNames.forEach((name) => url.searchParams.delete(name));
  return deniedNames.length > 0;
}

// Da chiamare in main.tsx PRIMA di createRouter: la root route non ha
// validateSearch, quindi un param estraneo entrerebbe nel search di
// TanStack Router e da lì nei filtri API delle tabelle → 400.
export function sanitizeBootUrl() {
  const url = new URL(window.location.href);
  if (!removeDeniedParams(url)) return;
  window.history.replaceState(window.history.state, '', url.toString());
}
